var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgExpiryFlag = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H9.56998C9.70809 0 9.82005 0.111939 9.82005 0.25002C9.82005 0.293529 9.80865 0.336287 9.78705 0.374065L8.00065 3.50028L9.78705 6.62649C9.85555 6.7464 9.8139 6.89911 9.69404 6.96762C9.65623 6.98922 9.61348 7.00057 9.56998 7.00057H1.00008V9.50077H0V0Z",
    fill: "#D92D20"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExpiryFlag, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ExpiryFlag.8679a91b.svg";
export { ForwardRef as ReactComponent };